import styled from 'styled-components'

const TrendsBody = styled.div`
  height: 15rem;
  overflow-y: auto;
  /* overflow-x: hidden; */
`

export default TrendsBody